import React from 'react';
import { LinkText } from '@/components/atoms'
import CustomDataTable from '@/components/organisms/CustomDataTable/CustomDataTable'
import { useActivites } from '@/containers/Activity/useActivites'
import { getCellDataMappedCols } from '@/helpers/dataTableCellDataMapper'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ROUTES } from '@/utils/constants/routesConstants'

const cellDataMapperObj = navigate => ({
  activityTitle: {
    cellData: ({ row: { original } = {} }) => {

      const queryParam = `?review=${original?.status}`;
      return (
        <LinkText
          text={original?.activityTitle}
          id={original?.activityTitle + ' ' + original?.id || original?.uuid}
          handleClick={() => navigate(`${ROUTES.ACTIVITY_VIEW.replace(':id', original?.id || original?.uuid)}${queryParam}`)}
        />
      );
    },
    linkHandler: (row) => {

      const queryParam =  `?review=${row?.status}`;
      return navigate(`${ROUTES.ACTIVITY_VIEW.replace(':id', row?.id || row?.uuid)}${queryParam}`);
    },
    linkLabel: (row) => row.activityTitle || '—',
  },
  customers_count: ({ row: { original } = {} }) => {
    return <div className="txtRightAlign">{original?.numberOfCustomers}</div>
  },
  percent_completed: ({ row: { original } = {} }) => {
    return <div className="txtRightAlign">{original?.percentageCompleted}</div>
  },
  points_awarded: ({ row: { original } = {} }) => {
    return <div className="txtRightAlign">{original?.totalPointsAwarded}</div>
  },
  status: ({ row: { original } = {} }) => {
    return <div className={original?.status === 'Cancelled' ? 'status_error' : ''}>{original?.status}</div>
  },
})
export const SalesTargetsActivitiesList = () => {
  const {
    activityListData,
    activityLColConfigData,
    pageIndex,
    setPageIndex,
    setSortingObj,
    sortingObj,
    setSearchArry,
    onDownloadBtnClick,
    handleResetAll,
    isPending,
    isError
  } = useActivites()

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [rowSelected, setRowSelected] = useState([])
  const [isSelectAll, setIsSelectAll] = useState(false)
  const navigate = useNavigate()
  const cellDataMappedCols = getCellDataMappedCols(cellDataMapperObj(navigate), activityLColConfigData)

  const isLoading = isPending

  const onDownloadClick = async (selectedRows) => {
    // selectedRows is empty array when select all is active (passed from CustomDataTable)
    // Otherwise it contains the selected row objects
    const ids = selectedRows?.length > 0 
      ? selectedRows.map(item => item?.id || item?.uuid)
      : [];
    onDownloadBtnClick(ids)
  }

  return (
    <div className="salesTargetsActiviesDataTable">
      <CustomDataTable
        columns={cellDataMappedCols}
        records={isError ? [] :(activityListData?.data || [])}
        isLoading={isLoading}
        pageSize={activityListData?.pageSize || 10}
        totalRecords={activityListData?.totalRecords || 0}
        setPageIndex={setPageIndex}
        handleSorting={setSortingObj}
        setSearchArry={setSearchArry}
        onResetAll={handleResetAll}
        onRowSelect={(selectedRecords, isAll) => {
          setRowSelected(selectedRecords)
          setIsSelectAll(isAll)
        }}
        onDownload={onDownloadClick}
        showDownload={true}
        isSelectAll={isSelectAll}
        pageIndex={pageIndex}
        initialSortConfig={sortingObj}
      />
      {activityListData?.totalRecords > 0 && (
        <div className="txtRightAlign">{activityListData?.totalRecords} total items</div>
      )}
    </div>
  )
}
